<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;" *ngIf="!isMyReport">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;New Client Declaration</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body" *ngIf="!isMyReport">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedProfile"
              (change)="onProfileChanged()"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Name<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployee"
              (change)="onEmployeeSelect()"
            >
              <option value="">Select Employee</option>
              <option
                *ngFor="let employee of employeeList"
                [ngValue]="employee"
              >
                {{ employee.firstName }} {{ employee.middleName }}
                {{ employee.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Client Name<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClient"
            >
              <option value="">Select Client</option>
              <option *ngFor="let client of clientList" [ngValue]="client">
                {{ client.clientName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Report
            </button>
          </div>

          <div class="col-sm-4" *ngIf="showExcelButton">
             <button
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="onExportToExcelReport()"
          >
            Export To Excel
          </button></div>

          <div class="col-sm-4" *ngIf="showExcelButton">
            <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
              <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
            </button>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container" id="mainContent" *ngIf="clientIndependence != null">
  <div class="row pt-3 col-sm-8 justify-content-center text-center">
    <span class="bg-theme-title"
      >P G BHAGWAT LLP, Chartered Accountants
    </span>
  </div>
  <div class="row col-sm-8 justify-content-center text-center ">
    <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
  </div>
  <div class="row pt-3">
    <div class="row col-sm-10">
      <h3 class="col-sm-10" style="text-align: center">
        Client Independence Confirmation
      </h3>
    </div>
  </div>
  <div class="row mt-2">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Name of Client: </label>
      </div>
      <div class="col-sm-4">
        <label class="col-sm-10 col-form-label">{{
          clientIndependence.clientName
        }}</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Legal Status: </label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >{{ clientIndependence.legalStatus }}
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Branch:</label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">{{
          clientIndependence.branch
        }}</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Client Added on: </label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >{{ clientIndependence.addedOn | date: "dd-MMM-yyyy  h:mm a" }}
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Assignments: </label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          ><span
            *ngFor="
              let assignment of clientIndependence.clientAssignment;
              let i2 = index;
              let first = first;
              let last = last
            "
            >{{ assignment.name }}
            <span
              *ngIf="i2 < clientIndependence.clientAssignment.length && !last"
            >
              ,
            </span>
            <span *ngIf="last"> . </span>
          </span>
        </label>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="row col-sm-10">
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label">Partner Assigned:</label>
      </div>
      <div class="col-sm-5">
        <label class="col-sm-10 col-form-label"
          >{{ clientIndependence.partnerFname }}
          {{ clientIndependence.partnerLname }}
        </label>
      </div>
    </div>
  </div>
  <br />
  <div class="row col-sm-10">
    <label class="col-sm-10 col-form-label">DETAILED DECLARATIONS</label>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10">{{ clientIndependence.beginText }}</label>
  </div>
  <div class="table-responsive cnstr-record col-sm-10">
    <table class="table table-bordered heading-hvr">
      <tr>
        <th>Sr. No</th>
        <th style="width: 80%">Declaration</th>
        <th>Agree / Disagree</th>
        <!-- <th>Disagree</th> -->
      </tr>
      <tbody
        *ngFor="
          let questions of clientIndependence.declarationDetails;
          let i = index
        "
      >
        <tr>
          <td>{{ i + 1 }}</td>
          <td>{{ questions.question }}</td>
          <td>
            <input
              type="checkbox"
              [checked]="validateAggreQuestion(questions.answer)"
              disabled
            />
          </td>
          <!-- <td> <input type="checkbox" [checked]="validateDisAggreQuestion(questions.answer)" disabled> </td> -->
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10 col-form-label"
      >Explanation in cases where 'disagree' responses are given</label
    >
  </div>
  <div class="row col-sm-10">
    <span class="col-sm-10">{{ clientIndependence.dissagreementAnswer }}</span>
  </div>
  <br />

  <div class="row col-sm-10">
    <label class="col-sm-10">{{ clientIndependence.declaration }}</label>
  </div>

  <div class="row col-sm-10">
    <label class="col-sm-10 col-form-label">REPRESENTATION</label>
  </div>
  <div class="row col-sm-10">
    <label class="col-sm-10">{{ clientIndependence.endText }}</label>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Sign:</div>
    <div class="col-sm-2"><input type="checkbox" checked disabled /></div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Name of Article/Employee/Partner:</div>
    <div class="col-sm-4">
      {{ clientIndependence.firstName }} {{ clientIndependence.middleName }}
      {{ clientIndependence.lastName }}
    </div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Designation:</div>
    <div class="col-sm-4">{{ clientIndependence.role }}</div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Date of joining:</div>
    <div class="col-sm-4">
      {{ clientIndependence.joiningDate | date: "dd-MMM-yyyy" }}
    </div>
  </div>
  <div class="row col-sm-10">
    <div class="col-sm-2">Date:</div>
    <div class="col-sm-4">
      {{ clientIndependence.signedDate | date: "dd-MMM-yyyy" }}
    </div>
  </div>
</div>
</div>